export default __webpack_public_path__ + "static/media/contact-hero.20bec065.svg";